// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"b0897ddc","2673":"18e4a308"}[chunkId] + ".chunk.css";
};